import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import DOMPurify from "dompurify";
import { api, errorMessage } from "../lib/api";
import { shortDate } from "../lib/format";

export default function ContentPage() {
  const slug = useLocation().pathname.replace("/", "") === "terms" ? "terms" : "faq";
  const { data, error } = useQuery<{ slug: string; title: string; html: string; updated_at: string | null }>({ queryKey: ["content", slug], queryFn: () => api.get(`/content/${slug}`).then((r) => r.data) });
  return (
    <div className="max-w-3xl" data-testid={`content-page-${slug}`}>
      <div className="eyebrow">Wine Club</div>
      <h1 className="mt-3 font-serif text-4xl font-medium tracking-tight sm:text-5xl" data-testid="content-title">{data?.title || (slug === "terms" ? "Terms & Conditions" : "FAQ")}</h1>
      {error && <p className="mt-6 text-sm text-[var(--wine)]">{errorMessage(error)}</p>}
      {data && <div className="prose-wine mt-8 space-y-4 text-sm leading-relaxed text-neutral-800 [&_h2]:font-serif [&_h2]:text-2xl [&_h3]:mt-8 [&_h3]:font-serif [&_h3]:text-xl [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.html, { USE_PROFILES: { html: true } }) }} data-testid="content-body" />}
      <div className="mt-12 flex flex-wrap gap-6 border-t border-border pt-6 text-xs text-neutral-500">
        {data?.updated_at && <span>Last updated {shortDate(data.updated_at)}</span>}
        <Link to={slug === "faq" ? "/terms" : "/faq"} className="underline underline-offset-4" data-testid="content-switch">{slug === "faq" ? "Terms & Conditions →" : "Wine Club FAQ →"}</Link>
        <Link to="/contact" className="underline underline-offset-4">Still have a question? Contact us →</Link>
      </div>
    </div>
  );
}
